<template>
  <div class="navbar">
    <div class="system-name">{{appName}}</div>
    <div class="user-info">
      <el-dropdown>
      <span class="el-dropdown-link">
        {{name}}<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native.prevent="gotoApps">应用列表</el-dropdown-item>
          <el-dropdown-item @click.native.prevent="userinfo">个人信息</el-dropdown-item>
          <el-dropdown-item @click.native.prevent="FedLogOut">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'nav-bar',
  computed: {
    ...mapGetters(['name', 'role', 'appName', 'appNo'])
  },
  methods: {
    ...mapActions(['FedLogOut']),
    userinfo () {
      this.$router.push(`/info${this.appNo}`)
    },
    gotoApps () {
      this.$router.push('/')
    }
  },
  watch: {
    name: {
      handler (val) {
        if (!val) {
          this.$store.dispatch('GenerateUserInfo')
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .navbar {
    background: #fff;
    height: 50px;
    padding: 0 20px;
    border-bottom: 1px solid #d8dce5;
    -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);
    .system-name {
      line-height: 50px;
      float: left;
    }
    .user-info {
      padding-top: 13px;
      line-height: 25px;
      float: right;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue